const validate = values => {
  const errors = {}

  if (!values?.password) {
    errors.password = "This field is required"
  }

  if (!values?.confirmPassword) {
    errors.confirmPassword = "This field is required"
  }

  if (
    values?.password &&
    values?.confirmPassword &&
    values?.password != values?.confirmPassword
  ) {
    errors.confirmPassword = "Password & Confirm Password do not match"
  }

  return errors
}

export default validate
